import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type";

/**
 * As we have decided to show featured routes both at the top and standardly in the list,
 * re-add featured routes into routes array, but remove the isFeaturedFlag
 */
export default function readdFeaturedRoutesAsNormalRoutes(routes: RouteWithAddedPropsAndPricesType[]) {
    const featuredRoutes = routes.filter((route) => (
        route.isFeatured
    ))

    const unfeaturedRoutes: RouteWithAddedPropsAndPricesType[] = featuredRoutes.map((route) => ({
        ...route,
        isFeatured: false,
    }))

    return [
        ...routes,
        ...unfeaturedRoutes,
    ]
}